import { Component, OnInit, ViewChild, Directive, ElementRef, ComponentFactoryResolver } from '@angular/core';
import { NavController, Platform, LoadingController, MenuController, AlertController, ModalController } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { PopoverController } from '@ionic/angular';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { PopoverComponent } from '../../popover/popover.component';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { TextToSpeech } from '@ionic-native/text-to-speech/ngx';
import { SpeechRecognition } from '@ionic-native/speech-recognition/ngx';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as moment from 'moment';
declare var window: any;
import { Idle, DEFAULT_INTERRUPTSOURCES } from 'ng2-idle-core';
import { FeedbackModal } from '../feedbackModal/feedbackModal.component';
// var window : any
// import { Route } from '@angular/router';




@Component({
  selector: 'app-va-chat',
  templateUrl: './va-chat.page.html',
  styleUrls: ['./va-chat.page.scss'],
})



export class VaChatPage implements OnInit {

  @ViewChild('content', { static: true }) content: any;
  @ViewChild('chattxt', { static: true }) sInput: any;
  @Directive({ selector: '[app-va-chat]' })

  context: any;
  vachattxt: any;
  speechenable: any = false;
  SelectIndex: any = 999999999;
  SelectedChat: any;
  clipboardList: any;
  languageContext: any;
  searchText: any;
  currentSearchedidx: any;
  welcomeQuery: any;
  welcomeprospect: any;
  tackbackquery: any;
  tackbackInterval: any
  recognition: any;
  fabsub: any;
  Subqueries: any;
  loader: any;
  capsuleConvID: any;
  showvoicepopup: any = false;
  reminderId: any;
  respindx: any;
  audio = new Audio();
  SearchJson: any;
  Indxvar: any;
  speechData: any;
  sendTimeout: any;
  clearlisten: any;
  ActionBlock: boolean = true;
  speechList: any;
  contexalpopup: any;
  popcontnt: any;
  contpopupCont: any;
  showinformationpopup: any = false;
  popupcontent: any;
  informationpopup: any;
  popupBtn: any;
  popupUrl: any;
  popupAction: any;
  userType: any;
  clearInter: any;
  FilterFix: any = 0;
  welcomeresq: any;
  storeOtp: any;
  limitExceed: boolean;
  storeOtpId: any;
  storeMessage: any;
  storeColorNumber: any = 0;
  storeChatData: any;
  storephoneno: any;
  storeDownloadAppData: boolean;
  sendChatData: boolean;
  storeLinkText: any;
  capList: any = [];
  feedbackSentence: any;

  // demotext = "<img width='32px' src='assets/images/va/icn_unlike.png'>";


  constructor(public router: Router, public menuCtrl: MenuController, public _sanitizer: DomSanitizer, public file: File, public fileopener: FileOpener, public tts: TextToSpeech, public SpeechRecognition: SpeechRecognition, public voiceLoader: LoadingController, public action: ActionlistenService, public clipboard: Clipboard, public popoverController: PopoverController, public platform: Platform, public navCtrl: NavController, public api: RestapiService, public cmndeclaration: CommonDeclarationService, public cmndef: CommonDefinitionService, public inappbrowser: InAppBrowser, private cd: ChangeDetectorRef, private idle: Idle, public alertController: AlertController,  public modalCtrl: ModalController) {
    this.idle.setIdle(10);
    this.idle.setTimeout(600);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);



    this.idle.onTimeout.subscribe(() => {
      this.presentAlertConfirm();
      // localStorage.clear();
    });

    this.idle.watch();

    this.vachattxt = '';
    this.fabsub = "";
    this.welcomeQuery = '&Existing_Welcome';
    this.welcomeprospect = '&Prospect_Welcome';
    this.tackbackquery = 'in@activeUserQuery';
    this.searchText = '';
    this.currentSearchedidx = 0;
    this.cmndeclaration.HeaderType = 'normal';
    this.speechList = ['100', '110', '120', '125', '135']
    this.userType = localStorage.role;

    this.cmndeclaration.getJson("en", "set").then(data => {
      localStorage.languageJson = JSON.stringify(data);
      this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
      this.languageContext = this.cmndeclaration.LanguageJson['pages'][0];
      this.cmndeclaration.lblButtons = this.languageContext.buttons;
      this.languageContext = this.languageContext.va;
      this.cmndeclaration.chatHeaderheading = this.languageContext.appname;
      this.cmndeclaration.chatplaceholder = this.languageContext.typemsg;
      this.cmndeclaration.jumppopup = this.languageContext.shorcut;
      this.cmndeclaration.miclbl = this.languageContext.listening;
      this.cmndeclaration.searchplaceholder = this.languageContext.searchtxt;
    }, err => {

    });
    // if (this.cmndeclaration.LanguageJson) {
    //   this.languageContext = this.cmndeclaration.LanguageJson.pages[0];
    // } else {
    //   this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
    //   this.languageContext = this.cmndeclaration.LanguageJson['pages'][0];
    // }


    // if (localStorage.role != 'new') {
    //   if (localStorage.htwpopup == undefined || localStorage.htwpopup == "") {
    //     this.cmndeclaration.howtouse = true;
    //     localStorage.htwpopup = "shown";
    //     this.clearInter = setInterval(() => {
    //       if (!this.cmndeclaration.howtouse) {
    //         clearInterval(this.clearInter);
    //         this.callinformationpopup();
    //       }
    //     }, 1000);
    //   } else {
    //     this.cmndeclaration.howtouse = false;
    //     this.callinformationpopup()
    //   }
    // }

    this.platform.ready().then(() => {
      this.getPushData();
      // this.loadContexalmenu();
      this.cmndeclaration.contentscroll = this.content;
      this.canceltackback("call");
      setTimeout(() => {
        this.cmndeclaration.loginedFlg = 'exist';
        this.cmndeclaration.Scrollbottom();
      }, 6000);

      this.platform.pause.subscribe(() => {
        this.cancelSpeech();
        this.canceltackback("nocall");
      });

      this.platform.resume.subscribe(() => {
        this.canceltackback("call");
      })
    });
  }

  ionViewWillEnter() {
    this.menuCtrl.swipeEnable(false);
  }

  async presentModal() {
    const modal = await this.modalCtrl.create({
        component: FeedbackModal,
    });
    modal.onDidDismiss()
        .then((data) => {
          console.log(data);
            // console.log("dismiss", data);
            // if (data['data'] != undefined) {
            //     // let cn = data['data'];
            //     this.country = data['data'];
            //     this.checkpincode();
            //     console.log(this.country)
            // }
        });
    return await modal.present();
}

  async presentAlertConfirm() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Session Timeout',
      message: "Click on Reset to start a new session.",
      buttons: [
        {
          text: 'Reset',
          handler: () => {

            localStorage.clear();
            this.clearChat();
          }
        }
      ]
    });

    await alert.present();
  }

  async ngOnInit() {
    localStorage.removeItem('userSessionId');
    localStorage.removeItem('userChatSessionId');
    let resq: any;
    this.cmndeclaration.checkMobileAuth = false;
    await this.api.initSession();
    this.welcomeresq = {
      "userSessionID": localStorage.userSessionId,
      "userChatSessionID": localStorage.userChatSessionId,
      "queryReq": "Welcome To MetLife",
      "speechMode": 0,
      "langCode": "en",
      "metadata": {
        "channelId": "1",
        "ip": "",
        "imei": "",
        "platform": "",
        "deviceVersion": "",
        "deviceModel": "",
        "version": "1.0.0"
      }
    }
    resq = {
      "userSessionID": localStorage.userSessionId,
      "userChatSessionID": localStorage.userChatSessionId,
      "queryReq": "Welcome To MetLife",
      "speechMode": 0,
      "langCode": "en",
      "metadata": {
        "channelId": "1",
        "ip": "",
        "imei": "",
        "platform": "",
        "deviceVersion": "",
        "deviceModel": "",
        "version": "1.0.0"
      }
    };
    this.Sendchat("welcome", resq);
  }


  async getPushData() {
    // await this.api.initSession();
    // this.triggerMessage(this.welcomeQuery);
    // this.Sendchat("welcome", req);
  }

  getChatData() {

    let ChatOldData: any;
    this.cmndeclaration.loginCheck = false;
    this.cmndeclaration.getChatHistory().then(async data => {
      ChatOldData = data;
      this.cmndeclaration.ChatfullList = [];
      if (localStorage.log == 'enable')
        this.cmndeclaration.loginedFlg = 'new';
      if (ChatOldData.length == 0) {
        localStorage.log = "disable"
        if (localStorage.role == 'existing')
          this.triggerMessage(this.welcomeQuery);
        else
          this.triggerMessage(this.welcomeprospect);
        this.getNotification();
        this.getPushData();
      } else {
        if (ChatOldData.length > 15) {

          let len = ChatOldData.length - 15;
          for (let i = len; i < ChatOldData.length; i++) {
            this.cmndeclaration.ChatfullList.push(ChatOldData[i]);
          }
          setTimeout(() => {
            this.cmndeclaration.Scrollbottom();
            if (localStorage.logout == 'manual') {
              localStorage.logout = "auto"
              localStorage.log = "disable"
              if (localStorage.role == 'existing')
                this.triggerMessage(this.welcomeQuery);
              else
                this.triggerMessage(this.welcomeprospect);
            } else {
              this.Clearpreviouschat();
            }
            this.getNotification();
            this.getPushData();
          }, 1000);
        } else {
          localStorage.logout = 'manual';
          localStorage.role = 'existing';
          this.cmndeclaration.ChatfullList = ChatOldData;
          setTimeout(() => {
            this.cmndeclaration.Scrollbottom();
            if (localStorage.logout == 'manual') {
              localStorage.logout = "auto"
              localStorage.log = "disable"
              if (localStorage.role == 'existing') {
                this.triggerMessage(this.welcomeQuery);
              } else {
                this.triggerMessage(this.welcomeprospect);
              }
            } else {

              this.Clearpreviouschat();
            }
            this.getNotification();
            this.getPushData();
          }, 1000);
        }
      }
    });
  }

  async loadContexalmenu() {
    let rawData: any;
    this.cmndeclaration.contextualMenu = [];
    this.cmndeclaration.getstoreProcess("contexualmenu").then(async data => {
      rawData = data;
      if (localStorage.role == 'existing')
        this.cmndeclaration.contextualMenu = rawData.e1User.queries;
      else
        this.cmndeclaration.contextualMenu = rawData.p1User.queries;

      localStorage.usercontexual = JSON.stringify(this.cmndeclaration.contextualMenu);

      if (this.cmndeclaration.LanguageJson) {
        this.languageContext = this.cmndeclaration.LanguageJson.pages[0];
      } else {
        this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
        this.languageContext = this.cmndeclaration.LanguageJson['pages'][0];
      }
      this.cmndeclaration.lblButtons = this.languageContext.buttons;
      this.languageContext = this.languageContext.va;
      this.cmndeclaration.chatHeaderheading = this.languageContext.appname;
      this.cmndeclaration.chatplaceholder = this.languageContext.typemsg;
      this.cmndeclaration.jumppopup = this.languageContext.shorcut;
      this.cmndeclaration.miclbl = this.languageContext.listening;
      this.cmndeclaration.searchplaceholder = this.languageContext.searchtxt;
    })

  }


  updateCall() {
    let res: any;
    let response: any;
    res = {
      userChatSessionID: localStorage.userChatSessionId,
      userSessionID: localStorage.userSessionId
    };
    this.api.postapi("chatForCall", res).then(data => {

      response = data;
    }, err => {

    })
  }

  Scrollbottom() {
    this.content.scrollToBottom(300);
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  triggerMessage(query: any) {
    let resq: any;
    let pushData: any;
    let date = new Date();
    let curdate: any;
    let loadData: any;
    this.cancelSpeech();

    resq = {
      "userSessionID": localStorage.userSessionId,
      "userChatSessionID": localStorage.userChatSessionId,
      "queryReq": query,
      "speechMode": 0,
    };
    if ((query == this.welcomeQuery) || (query == this.welcomeprospect)) {
      curdate = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
      curdate = curdate + "  " + this.formatAMPM(date);
      pushData = {
        "cType": "welcome",
        "time": curdate
      }
      this.cmndeclaration.ChatfullList.push(pushData);
      this.cmndeclaration.ChatFullHistory.push(pushData);
      this.cmndeclaration.StoreChatHistory();
    }
    if (this.cmndeclaration.Networkstatus)
      this.Sendchat("welcome", resq);
    else {
      setTimeout(() => {
        this.cmndeclaration.Scrollbottom();
      }, 200)
      let chatIntervel = setInterval(() => {
        if (this.cmndeclaration.Networkstatus) {
          this.Sendchat("welcome", resq);
          clearInterval(chatIntervel)
        }
      }, 1000)
    }
  }

  sendcardsData(data, indx) {

    // const element = <HTMLElement> document.getElementsByClassName('khushiChat')[this.storeColorNumber];
    // element.style.backgroundColor = '#fff';
    // element.style.color = '#000';

    this.cancelSpeech();
    let CurrentTime: any;
    let pushdata: any;
    let resq: any;
    this.canceltackback("nocall");
    if (indx == this.cmndeclaration.ChatfullList.length - 1) {
      if (data.reminderId != undefined && data.reminderId != '') {
        this.reminderId = data.reminderId;
        this.cmndef.showConfirmAlert("", this.languageContext.deleteconfrm, 'reminder', this.languageContext.yes, this.languageContext.no)
      } else {
        CurrentTime = this.formatAMPM(new Date);
        pushdata = {
          "cType": "0",
          "text": data.actionName,
          "vText": data.actionType,
          "conversationId": "0",
          "time": CurrentTime
        }

        if (this.storeMessage == "Update Email id") {
          this.storeMessage = "Update Email Request"
        }
        if (this.storeMessage == "Update Mobile Number") {
          this.storeMessage = "Update Mobile Number Request"
        }
        if (this.storeMessage == "Update PAN") {
          this.storeMessage = "Update PAN Request"
        }
        if (this.storeMessage == "Update Address") {
          this.storeMessage = "Update Address Request"
        }
        if (this.storeMessage == "Update Name") {
          this.storeMessage = "Update Name Request"
        }
        if (this.storeMessage == "Change Nominee") {
          this.storeMessage = "Change Nominee"
        }
        if (this.storeMessage == "Update Bank Details") {
          this.storeMessage = "Update Bank Details";
        }
        if(this.storeMessage == "Change Frequency") {
          this.storeMessage = "Change Frequency";
        }

        if(data.actionVal == "No ") {
          this.presentModal();
          return false;
        }
        if (data.actionVal == "Yes " || data.actionVal == "No ") {
          convertToJson = data.actionVal;
        } else {
          var convertToJson = JSON.parse(data.actionVal);
          convertToJson.queryReq = this.storeMessage;
        }

        resq = {
          "userSessionID": localStorage.userSessionId,
          "userChatSessionID": localStorage.userChatSessionId,
          actionType: data.actionType,
          actionVal: convertToJson,
        };
        if (data.actionType == "Update_Policy") {
          localStorage.removeItem('policyNo');
          var getData = JSON.parse(data.actionVal);
          let getPolicyNo = getData.policy_no;

          localStorage.setItem('policyNo', getPolicyNo);
        }




        this.cmndeclaration.ChatfullList.push(pushdata);
        this.cmndeclaration.ChatFullHistory.push(pushdata);

        if (this.cmndeclaration.Networkstatus) {
          this.Sendchat("cards", resq);
          // this.sendMessage(this.storeMessage);
        }
        else {
          setTimeout(() => {
            this.cmndeclaration.Scrollbottom();
          }, 200)
          let chatIntervel = setInterval(() => {
            if (this.cmndeclaration.Networkstatus) {
              this.Sendchat("cards", resq);
              // this.sendMessage(this.storeMessage);
              clearInterval(chatIntervel)
            }
          }, 1000)
        }
      }
    }
    // const ele = <HTMLElement> document.getElementsByClassName('myChat')[this.storeColorNumber];
    // ele.style.backgroundColor = '#0061A0';
    // ele.style.color = '#fff';
    // this.storeColorNumber = this.storeColorNumber + 1;
  }

  async sendMessage(chatData) {
    if (chatData == "Update Email id") {
      chatData = "Update Email Request"
    }
    if (chatData == "Update Mobile Number") {
      chatData = "Update Mobile Number Request"
    }
    if (chatData == "Update PAN") {
      chatData = "Update PAN Request"
    }
    if (chatData == "Update Address") {
      chatData = "Update Address Request"
    }
    if (chatData == "Update Name") {
      chatData = "Update Name Request"
    }
    if (chatData == "Change Nominee") {
      chatData = "Change Nominee Request"
    }
    if (chatData == "Update Bank Details") {
      chatData = "Update Bank Details"
    }
    if(chatData == "Change Frequency") {
      chatData = "Change Frequency";
    }
    chatData = chatData.replace(/</g, "&lt;").replace(/>/g, "&gt;");

    // const element = <HTMLElement> document.getElementsByClassName('khushiChat')[this.storeColorNumber];
    // element.style.backgroundColor = '#fff';
    // element.style.color = '#000';

    let CurrentTime: any;
    let pushdata: any;
    let resq: any;
    this.canceltackback("nocall");

    if (this.cmndeclaration.checkMobileNumberEntered) {

      this.storephoneno = chatData;
      this.storeChatData = chatData;
    }
    if (this.limitExceed) {
      this.storeOtp = '123456';
    }
    // if (this.cmndeclaration.checkOtpEntered) {

    // this.cmndeclaration.checkMobileAuth = true;
    // if (localStorage.policyNo != undefined || localStorage.policyNo == null) {
    // chatData = "i want to change my policy";
    //   this.cmndeclaration.checkMobileNumberEntered = false;
    //   this.cmndeclaration.checkOtpEntered = false;
    // } else {
    //   chatData = this.storeMessage;
    // }
    // this.cmndeclaration.checkOtpEntered = false;
    //   resq = {
    //     "otpid": this.storeOtpId,
    //     "otp": chatData,
    //     "actionType": "otp_validation",
    //     "actionVal": "i want to change my policy",
    //     "userSessionID": localStorage.userSessionId,
    //     "userChatSessionID": localStorage.userChatSessionId,
    //   };
    // 
    //   this.Sendchat("cards", resq);
    //   this.cmndeclaration.checkMobileNumberEntered = false;
    // }

    if (chatData != "" && chatData != undefined && chatData != " ") {
      CurrentTime = this.formatAMPM(new Date);
      this.capList = [];
      pushdata = {
        "cType": "0",
        "text": chatData,
        "vText": chatData,
        "conversationId": "0",
        "time": CurrentTime
      }

      if (chatData == "Resend OTP") {
        resq = {
          "actionType": "resendOtp",
          "actionVal": this.storephoneno,
          "userSessionID": localStorage.userSessionId,
          "userChatSessionID": localStorage.userChatSessionId,
        };
      } else if (this.storeDownloadAppData) {
        resq = {
          "actionType": "downloadKhushiApp",
          "actionVal": chatData,
          "userSessionID": localStorage.userSessionId,
          "userChatSessionID": localStorage.userChatSessionId,
        };
        this.sendChatData = true;
      } else if (this.cmndeclaration.checkOtpEntered) {
        resq = {
          "otpid": this.storeOtpId,
          "otp": chatData,
          "actionType": "otp_validation",
          "actionVal": "i want to change my policy",
          "userSessionID": localStorage.userSessionId,
          "userChatSessionID": localStorage.userChatSessionId,
        };

        // this.Sendchat("cards", resq);
      }
      // else if (this.cmndeclaration.checkOtpEntered && chatData != this.storeOtp) {
      //   resq = {
      //     "actionType": "InvalidOTP",
      //     "actionVal": chatData,
      //     "userSessionID": localStorage.userSessionId,
      //     "userChatSessionID": localStorage.userChatSessionId,
      //   };
      // }
      else if (this.cmndeclaration.checkMobileNumberEntered) {
        resq = {
          "actionType": "mobileauth",
          "actionVal": chatData,
          "userSessionID": localStorage.userSessionId,
          "userChatSessionID": localStorage.userChatSessionId,
        };
      }
      else {
        resq = {
          "userSessionID": localStorage.userSessionId,
          "userChatSessionID": localStorage.userChatSessionId,
          "queryReq": chatData,
          "speechMode": 0,
        };
      }


      this.vachattxt = '';
      if (chatData != "Mobile Number Validation" && chatData != "i want to change my policy") {


        this.cmndeclaration.ChatfullList.push(pushdata);
        this.cmndeclaration.ChatFullHistory.push(pushdata);
      }

      if (chatData == "Mobile Number Validation") {
        pushdata = {
          "cType": "0",
          "text": this.storeChatData,
          "vText": this.storeChatData,
          "conversationId": "0",
          "time": CurrentTime
        }
        this.cmndeclaration.ChatfullList.push(pushdata);
        this.cmndeclaration.ChatFullHistory.push(pushdata);
      }
      if (chatData == "i want to change my policy") {
        pushdata = {
          "cType": "0",
          "text": this.storeChatData,
          "vText": this.storeChatData,
          "conversationId": "0",
          "time": CurrentTime
        }
        this.cmndeclaration.ChatfullList.push(pushdata);
        this.cmndeclaration.ChatFullHistory.push(pushdata);
      }

      if (this.storeChatData == "Download Mobile App") {
        this.storeDownloadAppData = true;
      }
      this.cmndeclaration.StoreChatHistory();
      this.cd.detectChanges();
      this.cmndeclaration.Scrollbottom();


      if (this.cmndeclaration.Networkstatus) {
        if (this.cmndeclaration.checkMobileNumberEntered || this.cmndeclaration.checkOtpEntered) {

          this.Sendchat("cards", resq);
          this.cmndeclaration.checkMobileNumberEntered = false;
        } else if (this.sendChatData) {
          this.Sendchat("cards", resq);
          this.sendChatData = false;
        } else {
          this.Sendchat("chat", resq);
        }
      } else {
        setTimeout(() => {
          this.cmndeclaration.Scrollbottom();
        }, 200)
        let chatIntervel = setInterval(() => {
          if (this.cmndeclaration.Networkstatus) {
            this.Sendchat("chat", resq);
            clearInterval(chatIntervel)
          }
        }, 1000)
      }
      // const element = <HTMLElement> document.getElementsByClassName('myChat')[this.storeColorNumber];
      // element.style.backgroundColor = '#0061A0';
      // element.style.color = '#fff';

      // this.storeColorNumber = this.storeColorNumber + 1;
    }
  }
  async HomeButton(flg: any, resq: any) {
    if (this.cmndeclaration.checkMobileAuth == false) {
      this.cmndeclaration.checkMobileNumberEntered = false;
    }
    this.storeDownloadAppData = false;
    this.sendChatData = false;
    this.storeLinkText = '';
    this.cmndeclaration.checkOtpEntered = false;
    this.storeOtp = '';
    this.limitExceed = false;
    this.Sendchat(flg, resq);
  }

  async Sendchat(flg: any, resq: any) {


    let response: any;
    let data: any;
    let path: any;
    let errData: any;
    let loadData: any
    loadData = {
      "cType": "loading"
    }
    this.cmndeclaration.ChatfullList.push(loadData);
    setTimeout(async () => {
      this.cmndeclaration.Scrollbottom();
    }, 200)
    this.ActionBlock = true;

    if (flg == 'cards')
      path = "webbotVAAction"
    else {
      if (localStorage.feedBack != undefined && localStorage.feedBack == 'enable') {
        path = "feedback";
        localStorage.removeItem("feedBack");
      }
      else
        path = "webbotChat"
    }
    this.cmndeclaration.DefaultPolicyBlock = false;


    await this.api.postapi(path, resq).then(res => {

      this.ActionBlock = true;
      if (res["reqQuery"][0].queryReq == "Mobile Number Validation" || res["reqQuery"][0].queryReq == "MobileNumber Validate" || res["reqQuery"][0].queryReq == "Download Mobile App") {
        this.ActionBlock = false;
        this.sInput.setFocus();
        if(res["reqQuery"][0].queryReq == "resendOtp") {
          this.storeOtpId = res['otpid'];
        }
      }
      if (res["reqQuery"][0].queryReq == "i want to change my policy") {
        this.cmndeclaration.checkOtpEntered = false;
        this.cmndeclaration.checkMobileAuth = true;
      }

      if (res['queryReq'] == "&OTPInvalidLimitExceeded") {
        this.limitExceed = true;
      }

      if (res['queryReq'] == "&MobileNumber Not Registered") {
        this.cmndeclaration.checkMobileNumberEntered = true;
      }

      if (res['queryReq'] == "&Improper MobileNumber") {
        this.cmndeclaration.checkMobileNumberEntered = true;
      }

      if (res["reqQuery"][0].queryReq == "otpvalidate") {
        this.ActionBlock = false;
        this.sInput.setFocus();
        this.cmndeclaration.checkOtpEntered = true;

        // this.storeOtp = atob(res['otp']);
        this.storeOtpId = res['otpid'];
        response = res;
      } else {
        response = res;
      }
      data = response.chatResp;
      if (data[0].text == "We have sent an SMS on your mobile number with a link to download our customer service app.") {
        this.storeDownloadAppData = false;
      }

      if (res["reqQuery"][0].queryReq == "Online Premium Payment") {
        this.storeLinkText = "Pay Now";
      } else if (res["reqQuery"][0].queryReq == "Policy Details") {
        this.storeLinkText = "Pay Now";
      } else if (res["reqQuery"][0].queryReq == "Premium Paid Certificate") {
        this.storeLinkText = "Premium Paid Certificate";
      } else if (res["reqQuery"][0].queryReq == "e-Policy Document") {
        this.storeLinkText = "E-Policy Document";
      } else if (res["reqQuery"][0].queryReq == "Premium Receipt") {
        this.storeLinkText = "Premium Receipt";
      } else if (res["reqQuery"][0].queryReq == "Account Statement") {
        this.storeLinkText = "Account Statement";
      } else if (res["reqQuery"][0].queryReq == "Intimate your claim") {
        this.storeLinkText = "Intimate your claim";
      } else if (res["reqQuery"][0].queryReq == "Track Your Claim") {
        this.storeLinkText = "Track Your Claim";
      } else if (res["reqQuery"][0].queryReq == "File a claim") {
        this.storeLinkText = "File a Claim";
      } else if (res["reqQuery"][0].queryReq == "Update Email Request") {
        this.storeLinkText = "Update Email ID";
      } else if (res["reqQuery"][0].queryReq == "Update Mobile Number Request") {
        this.storeLinkText = "Update Mobile Number";
      } else if (res["reqQuery"][0].queryReq == "Update PAN Request") {
        this.storeLinkText = "Update PAN Number";
      } else if (res["reqQuery"][0].queryReq == "Update Address Request") {
        this.storeLinkText = "Update Address";
      } else if (res["reqQuery"][0].queryReq == "Update Name Request") {
        this.storeLinkText = "Update Name";
      } else if (res["reqQuery"][0].queryReq == "Change Nominee Request" || res["reqQuery"][0].queryReq == "Change Nominee") {
        this.storeLinkText = "Change Nominee";
      } else if (res["reqQuery"][0].queryReq == "Update Bank Details") {
        this.storeLinkText = "Update Bank Details";
      } else if (res["reqQuery"][0].queryReq == "Change Frequency") {
        this.storeLinkText = "Change Frequency";
      }

      data.forEach(element => {
        element["time"] = this.formatAMPM(new Date);
        if (localStorage.language == "hi") {
          if (element.cType == "2") {
            for (let i = 0; i < element.buttons.length; i++) {
              if (this.cmndeclaration.lblButtons[element.buttons[i].actionName] != undefined && this.cmndeclaration.lblButtons[element.buttons[i].actionName] != "") {
                element.buttons[i].actionName = this.cmndeclaration.lblButtons[element.buttons[i].actionName]
                element.buttons[i].actionVal = this.cmndeclaration.lblButtons[element.buttons[i].actionVal]
              }
            }
          }
          if (element.cType == "4") {
            for (let i = 0; i < element.links.length; i++) {
              if (this.cmndeclaration.lblButtons[element.links[i].actionName] != undefined && this.cmndeclaration.lblButtons[element.links[i].actionName] != "") {
                element.links[i].actionName = this.cmndeclaration.lblButtons[element.links[i].actionName]
              }
            }
          }
          if (element.cType == "11") {
            if (this.cmndeclaration.lblButtons[element.actionName] != undefined && this.cmndeclaration.lblButtons[element.actionName] != "") {
              element.actionName = this.cmndeclaration.lblButtons[element.actionName]
            }
          }
          if (element.cType == "21") {
            for (let i = 0; i < element.Buttons.length; i++) {
              if (this.cmndeclaration.lblButtons[element.Buttons[i].actionName] != undefined && this.cmndeclaration.lblButtons[element.Buttons[i].actionName] != "") {
                element.Buttons[i].actionName = this.cmndeclaration.lblButtons[element.Buttons[i].actionName]
              }
            }
          }
        }
      });
      // this.ActionBlock = false;
      this.sInput.setFocus();
      if (localStorage.voiceenable == "true") {
        this.respindx = flg;
        this.SpeachText(response, data, 0, 'del');
      }
      else {
        this.cmndeclaration.ChatfullList.splice(this.cmndeclaration.ChatfullList.length - 1);
        if (flg == "chat") {
          if (response.reqQuery != undefined && response.reqQuery.length > 0 && response.reqQuery[0].conversationId != undefined)
            this.cmndeclaration.ChatfullList[(this.cmndeclaration.ChatfullList.length - 1)]['conversationId'] = response.reqQuery[0].conversationId;
        }

        data.forEach(element => {
          if (element.cType == "2") {
            setTimeout(async () => {

              await this.cmndeclaration.ChatfullList.push(element);
              await this.cmndeclaration.ChatFullHistory.push(element);
              this.feedbackSentence = '(On exit Feedback option will be auto populated.)';
              if (response.followUpResp != undefined && response.followUpResp != null && Object.keys(response.followUpResp[0]).length > 0) {
                this.capsuleConvID = element.conversationId;
                this.capList = response.followUpResp;
              }
              setTimeout(async () => {
                this.cmndeclaration.Scrollbottom();
              }, 200)
            }, 3000);
          } else {
            this.cmndeclaration.ChatfullList.push(element);
            this.cmndeclaration.ChatFullHistory.push(element);

            if (response.followUpResp != undefined && response.followUpResp != null && Object.keys(response.followUpResp[0]).length > 0) {
              this.capsuleConvID = element.conversationId;
              this.capList = response.followUpResp;
            }
          }

        });
        setTimeout(async () => {
          this.cmndeclaration.Scrollbottom();
          // await this.cd.detectChanges();
        }, 200);
        this.cmndeclaration.StoreChatHistory();
        // this.cd.detectChanges();
        this.canceltackback("call");
      }
    }, err => {
      errData = {
        "cType": "1",
        "text": this.languageContext.invalidquery.label,
        "conversationId": "0",
        "time": this.formatAMPM(new Date)
      }
      // this.ActionBlock = false;
      this.sInput.setFocus();
      this.cmndeclaration.ChatfullList.splice(this.cmndeclaration.ChatfullList.length - 1);
      this.cmndeclaration.ChatfullList.push(errData);
      this.cmndeclaration.ChatFullHistory.push(errData);
      setTimeout(() => {
        this.cmndeclaration.Scrollbottom();
      }, 200);
      this.cmndeclaration.StoreChatHistory();
    });
  }
  openLinks(data) {
    if (this.validURL(data.URI)) {
      window.open(data.URI);
    }
  }

  minimizeChats() {

    CommonDeclarationService.minimizeChat(true);
  }

  capsuledata(data: any) {
    var getPosition = this.cmndeclaration.ChatfullList.length - 1;
    if (this.cmndeclaration.ChatfullList[getPosition].cType == "19") {
      this.cmndeclaration.ChatfullList[getPosition].cType = 1;
    }


    this.api.clickenventcap(data);
    this.storeChatData = data;
    // const elment = <HTMLElement> document.getElementsByClassName('khushiChat')[0];
    // element.style.backgroundColor = '#fff';
    // element.style.color = '#000';
    if (this.validURL(data)) {
      window.open(data);
    } else if (data == "Fund Amount" || data == "Policy Details" || data == "Last Premium Paid" || data == "Premium Details" || data == "Maturity Date" || data == "Policy Issue Date" || data == "Premium Paid Certificate" || data == "Renewal Due Notice" || data == "e-Policy Document" || data == "Premium Receipt" || data == "Account Statement" || data == "Online Premium Payment" || data == "Update Email id" || data == "Update Mobile Number" || data == "Update address" || data == "Update PAN" || data == "Update Address" || data == "Update Name" || data == "Change Nominee" || data == "Change nominee" || data == "Update Bank Details" || data == "Change Frequency" || data == "Change payment mode/ frequency" || data == "Unclaimed Amount") {
      if (this.cmndeclaration.checkMobileAuth && localStorage.policyNo != null && localStorage.policyNo != undefined) {
        this.sendMessage(data);
      } else {

        this.storeMessage = data;

        this.sendMessage("Mobile Number Validation");
        this.cmndeclaration.checkMobileNumberEntered = true;
        this.capList = [];
      }
    } else {
      this.capList = [];
      this.sendMessage(data);
    }
  }

  validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  }

  Loadingappbrowser(linkname: any, link: any) {
    var getPosition = this.cmndeclaration.ChatfullList.length - 1;
    if (this.cmndeclaration.ChatfullList[getPosition].cType == "4") {
      this.cmndeclaration.ChatfullList[getPosition].cType = 1;
    }

    var getPosition = this.cmndeclaration.ChatfullList.length - 2;
    if (this.cmndeclaration.ChatfullList[getPosition].cType == "4") {
      this.cmndeclaration.ChatfullList[getPosition].cType = 1;
    }
    
    this.cancelSpeech()
    this.api.clickenventcap("click_link_" + linkname.toLowerCase());

    if (this.cmndeclaration.BrowserBuild != 1)
      this.inappbrowser.create(link, "_blank");
    else
      window.open(link, "_blank");
  }

  handleCtype11(data: any, indx: any) {
    this.cancelSpeech()
    if (indx == this.cmndeclaration.ChatfullList.length - 1) {
      if (data.actionUrlType == 0) {
        if (this.cmndeclaration.DefaultPolicyBlock == true && data.URI != "openMap") {
          if (localStorage.language == "en")
            this.sendMessage("change policy");
          else {
            this.sendMessage("चेंज पॉलिसी");
          }
        } else {
          if (data.URI == "bankUpdate" && (data.actionName == 'Unclaimed Fund Bank Update' || data.actionName == 'अनक्लेम्ड फंड बैंक अपडेट')) {
            localStorage.setItem('bankformtype', 'BankUpdate_UnclaimedFund');
            sessionStorage.CurrentPage = "/bankform";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/bankform"]);
            this.navCtrl.navigateForward("/bankform");
          }
          else if (data.URI == "bankUpdate" && (data.actionName == 'Bank Update' || data.actionName == 'बैंक अपडेट')) {
            localStorage.setItem('bankformtype', 'BankUpdate');
            sessionStorage.CurrentPage = "/bankform";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/bankform"]);
            this.navCtrl.navigateForward("/bankform");
          }
          else if (data.URI == "panForm") {
            sessionStorage.CurrentPage = "/va/panForm";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/panForm"]);
            this.navCtrl.navigateForward("/va/panForm");
          } else if (data.URI == "LinkPolicyForm") {
            sessionStorage.CurrentPage = "/va/linkpolicy";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/linkpolicy"]);
            this.navCtrl.navigateForward("/va/linkpolicy");
          } else if (data.URI == "nomineeForm") {
            sessionStorage.CurrentPage = "/va/nomineeForm";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/nomineeForm"]);
            this.navCtrl.navigateForward("/va/nomineeForm");
          } else if (data.URI == "Address_Update_Form") {
            sessionStorage.CurrentPage = "/va/addressForm";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/addressForm"]);
            this.navCtrl.navigateForward("/va/addressForm");
          } else if (data.URI == "aadharForm") {
            sessionStorage.CurrentPage = "/va/aadharForm";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/aadharForm"]);
            this.navCtrl.navigateForward("/va/aadharForm");
          } else if (data.URI == "changePassword") {
            this.redirectToOtpVerifyPage();
          }
          else if (data.URI == "Frequency_Update_Form") {
            sessionStorage.CurrentPage = "/va/changefrequency";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/changefrequency"]);
            this.navCtrl.navigateForward("/va/changefrequency");
          }
          else if (data.URI == "Appointee_Update_Form") {
            sessionStorage.CurrentPage = "/va/updateappointee";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/updateappointee"]);
            this.navCtrl.navigateForward("/va/updateappointee");
          }
          else if (data.URI == "Dob_Update_Form") {
            sessionStorage.CurrentPage = "/va/changedob";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/changedob"]);
            this.navCtrl.navigateForward("/va/changedob");
          }

          else if (data.URI == "Name_Update_Form") {
            sessionStorage.CurrentPage = "/va/updatename";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/updatename"]);
            this.navCtrl.navigateForward("/va/updatename");
          }
          else if (data.URI == "openMap") {


            let lat: any;
            let long: any;
            lat = data.lattitude;
            long = data.longitude;


            if (this.cmndeclaration.runPlatform == "ios")
              window.open('maps://maps.google.com/maps?daddr=' + parseFloat(lat) + ',' + parseFloat(long) + '&amp;ll=&amp;t=m', '_system');
            else if (this.cmndeclaration.runPlatform == "android")
              window.open('geo:0,0?q=' + parseFloat(lat) + ',' + parseFloat(long), '_system');
            else
              window.open('https://maps.google.com/maps?daddr=' + parseFloat(lat) + ',' + parseFloat(long) + '&amp;ll=&amp;t=m', '_system');
          }
          else if (data.URI == "RPR") {
            this.cmndef.headerType = 'one';

            this.getPolicyFrequency();
          } else if (data.URI == "RPN") {
            this.cmndef.headerType = 'two';
            this.getPolicyFrequency();
          } else if (data.URI == "PPC") {
            this.cmndef.headerType = 'three';
            sessionStorage.CurrentPage = "/documentdownload";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/documentdownload"]);
            this.navCtrl.navigateForward("/documentdownload");

          } else if (data.URI == "AS") {
            this.cmndef.headerType = 'four';
            sessionStorage.CurrentPage = "/documentdownload";
            this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/documentdownload"]);
            this.navCtrl.navigateForward("/documentdownload");
          }
        }
      }
      else if (data.actionUrlType == 1) {
        if (this.cmndeclaration.BrowserBuild != 1)
          this.inappbrowser.create(data.URI, "_blank");
        else
          window.open(data.URI, "_blank");
      }
    }

  }

  getPolicyFrequency() {
    this.cancelSpeech()
    var data = {
      "userSessionID": localStorage.userSessionId,
      "userChatSessionID": localStorage.userChatSessionId,
      "actionType": "GET_FREQUENCY"
    }
    this.api.postapi("akeiraVAAction", data).then(response => {
      if (response['responseCode'] == '001') {
        localStorage.setItem('policyFreq', response['frequency']);
        sessionStorage.CurrentPage = "/documentdownload";
        this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/documentdownload"]);
        this.navCtrl.navigateForward("/documentdownload");
      }

    })

  }

  async presentPopover(ev: any) {
    this.cancelSpeech()
    if (!this.ActionBlock) {
      this.cmndef.popover = await this.popoverController.create({
        component: PopoverComponent,
        event: ev,
        translucent: true
      });
      return await this.cmndef.popover.present();
    }
  }

  sendfeedback(msg: any) {
    let resq: any;
    let pushData: any;
    let curdate: any;
    let loadData: any;
    this.canceltackback("nocall");
    curdate = this.formatAMPM(new Date);
    pushData = {
      "cType": "1",
      "time": curdate,
      "text": msg
    }
    this.cmndeclaration.ChatfullList.push(pushData);
    this.cmndeclaration.ChatFullHistory.push(pushData);
    localStorage.feedBack = "enable";
    setTimeout(() => {
      this.cmndeclaration.Scrollbottom();
    }, 200);
    this.cmndeclaration.StoreChatHistory();
  }


  async SpeachText(data: any, response: any, idx: any, flg: any) {
    let lang: any;
    let resp: any
    let speechText: any;
    if (idx < response.length) {
      let req = response[idx];
      if (localStorage.language == 'hi')
        lang = "hi-IN"
      else
        lang = "en-IN"

      if (req.vText != undefined && req.vText != "") {
        speechText = {
          "text": "<speak><prosody volume='loud' rate='" + this.speechList[localStorage.speechrate] + "%'>" + req.vText + "</prosody></speak>",
          "voice": "Aditi",
          "LanguageCode": lang,
          "TextType": "ssml"
        }

        await this.cmndeclaration.Amazonpoliy(speechText).then(respo => {

          resp = respo;
          if (flg == 'del') {
            this.cmndeclaration.ChatfullList.splice(this.cmndeclaration.ChatfullList.length - 1);
            if (flg == "chat") {
              if (data.reqQuery != undefined && data.reqQuery.length > 0 && data.reqQuery[0].conversationId != undefined)
                this.cmndeclaration.ChatfullList[(this.cmndeclaration.ChatfullList.length - 1)]['conversationId'] = data.reqQuery[0].conversationId;
            }
          }
          this.audio.src = resp.url;
          this.audio.load();
          this.audio.play();
          this.cmndeclaration.ChatfullList.push(req);
          this.cmndeclaration.ChatFullHistory.push(req);
          if (data != "") {
            if (data.followUpResp != undefined && data.followUpResp != null && Object.keys(data.followUpResp[0]).length > 0) {
              this.capsuleConvID = data.conversationId;
              this.capList = data.followUpResp;
            }
          }
        }, err => {

          if (flg == 'del') {
            this.cmndeclaration.ChatfullList.splice(this.cmndeclaration.ChatfullList.length - 1);
            if (this.respindx == "chat") {
              if (data.reqQuery != undefined && data.reqQuery.length > 0 && data.reqQuery[0].conversationId != undefined)
                this.cmndeclaration.ChatfullList[(this.cmndeclaration.ChatfullList.length - 1)]['conversationId'] = data.reqQuery[0].conversationId;
            }
          }
          this.cmndeclaration.ChatfullList.push(req);
          this.cmndeclaration.ChatFullHistory.push(req);

          if (data != "") {
            if (data.followUpResp != undefined && data.followUpResp != null && Object.keys(data.followUpResp[0]).length > 0) {
              this.capsuleConvID = data.conversationId;
              this.capList = data.followUpResp;
            }
          }
        });
      } else {
        if (flg == 'del') {
          this.cmndeclaration.ChatfullList.splice(this.cmndeclaration.ChatfullList.length - 1);
          if (this.respindx == "chat") {
            if (data.reqQuery != undefined && data.reqQuery.length > 0 && data.reqQuery[0].conversationId != undefined)
              this.cmndeclaration.ChatfullList[(this.cmndeclaration.ChatfullList.length - 1)]['conversationId'] = data.reqQuery[0].conversationId;
          }
        }
        this.cmndeclaration.ChatfullList.push(req);
        this.cmndeclaration.ChatFullHistory.push(req);
        if (data != "") {
          if (data.followUpResp != undefined && data.followUpResp != null && Object.keys(data.followUpResp[0]).length > 0) {
            this.capsuleConvID = data.conversationId;
            this.capList = data.followUpResp;
          }
        }
      }
      setTimeout(() => {
        this.cmndeclaration.Scrollbottom();
        this.SpeachText(data, response, idx + 1, 'no')
      }, 200);
    } else {
      setTimeout(() => {
        this.cmndeclaration.Scrollbottom();
      }, 200);
      this.cmndeclaration.StoreChatHistory();
      // this.cd.detectChanges();
      this.canceltackback("call");
    }
  }


  updateforms(data: any, indx: any, fulldata: any) {
    this.cancelSpeech();
    if (indx == this.cmndeclaration.ChatfullList.length - 1) {

      if (this.cmndeclaration.DefaultPolicyBlock == true) {
        // this.cmndef.presentAlert("",this.cmndeclaration.LanguageJson.pages[0].alerts.defaultPolicy,"error")
        if (localStorage.language == "en")
          this.sendMessage("change policy");
        else {
          this.sendMessage("चेंज पॉलिसी");
        }
      } else {
        if (data.URI == "Email_Update_with_otp") {
          sessionStorage.CurrentPage = "/va/emailupdate";
          this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/emailupdate"]);
          this.navCtrl.navigateForward("/va/emailupdate");
        } else if (data.URI == "Email_Update_without_otp") {
          sessionStorage.CurrentPage = "/va/updateemail";
          this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/updateemail"]);
          this.navCtrl.navigateForward("/va/updateemail");
        } else if (data.URI == "Mobile_Update_with_otp") {
          sessionStorage.CurrentPage = "/va/mobileupdate";
          this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/mobileupdate"]);
          this.navCtrl.navigateForward("/va/mobileupdate");
        } else if (data.URI == "Mobile_Update_without_otp") {
          sessionStorage.CurrentPage = "/va/updatemobile";
          this.api.clickenventcap("open_" + this.cmndef.TrakcerFromValue["/va/updatemobile"]);
          this.navCtrl.navigateForward("/va/updatemobile");
        } else {
          if (fulldata.actionUrlType != undefined && fulldata.actionUrlType == 1)
            this.Loadingappbrowser(data.actionName, data.URI);
        }
      }

    }
  }


  cancelSpeech() {
    this.audio.pause();
    this.audio.currentTime = 0;
    this.audio.src = '';
  }

  callphone() {
    this.cancelSpeech()
    this.api.clickenventcap("call_button");
    this.cmndef.showConfirmAlert("", this.cmndeclaration.LanguageJson.pages[0].alerts.callCustomercarePrompt, "customercare", this.cmndeclaration.LanguageJson.pages[0].alerts.yes, this.cmndeclaration.LanguageJson.pages[0].alerts.no)
  }



  onPress(data, idx) {
    if (data.cType == 0 || data.conversationId == "" || data.conversationId == undefined || data.conversationId == "0")
      this.clipboardList = false;
    else
      this.clipboardList = true
    this.cmndeclaration.HeaderType = "clipboard";
    this.SelectIndex = idx;
    this.SelectedChat = data;
  }

  clipboardBack() {
    this.cmndeclaration.HeaderType = "normal";
    this.searchText = "";
    this.SelectIndex = 999999999;
    this.SelectedChat = '';
  }

  feedbackthump(flg: any, ConvId: any) {
    this.cancelSpeech()
    let pushData: any;
    let curdate: any;
    let resq: any;
    let feed: any;
    this.canceltackback("nocall");
    curdate = this.formatAMPM(new Date);
    if (flg == 'thumbs-up') {
      feed = 1;
      pushData = {
        "cType": "0",
        "time": curdate,
        "text": "<img width='32px' src='assets/images/va/icn_like.png'>"
      }
      // this.dispRateus();
    } else {
      feed = 0;
      pushData = {
        "cType": "0",
        "time": curdate,
        "text": "<img width='32px' src='assets/images/va/icn_unlike.png'>"
      }
    }
    this.cmndeclaration.ChatfullList.push(pushData);
    this.cmndeclaration.ChatFullHistory.push(pushData);
    localStorage.feedBack = "enable";
    this.capList = '';
    resq = {
      "userSessionID": localStorage.userSessionId,
      "userChatSessionId": localStorage.userChatSessionId,
      "conversationId": ConvId,
      "feedback": String(feed),
      "feedbackText": "",
      "followUpRespId": ""
    };
    this.clipboardBack();
    if (this.cmndeclaration.Networkstatus)
      this.Sendchat("chats", resq);
    else {
      setTimeout(() => {
        this.cmndeclaration.Scrollbottom();
      }, 200)
      let chatIntervel = setInterval(() => {
        if (this.cmndeclaration.Networkstatus) {
          this.Sendchat("chats", resq);
          clearInterval(chatIntervel)
        }
      }, 1000)
    }
  }

  starredmessage() {
    this.cancelSpeech()
    let res: any;
    let len: any;
    let starlen: any;

    this.canceltackback("nocall");
    res = {
      "conversationId": this.SelectedChat['conversationId'],
      "starred": "1",
      "userChatSessionId": localStorage.userChatSessionId,
      "userSessionID": localStorage.userSessionId
    }
    len = (this.cmndeclaration.ChatfullList.length) - this.SelectIndex;
    starlen = (this.cmndeclaration.ChatFullHistory.length) - len;
    this.api.postapi("starredMessage", res).then(data => {
      this.cmndeclaration.ChatfullList[this.SelectIndex]['starredmsg'] = 'true';
      this.cmndeclaration.ChatfullList[this.SelectIndex]['starreddate'] = moment(new Date()).format("MMMM Do YYYY, h:mm a");
      this.cmndeclaration.ChatFullHistory[starlen]['starredmsg'] = 'true';
      this.cmndeclaration.ChatFullHistory[starlen]['starreddate'] = moment(new Date()).format("MMMM Do YYYY, h:mm a");
      this.clipboardBack();
      this.canceltackback("call");
      this.cmndeclaration.StoreChatHistory();
      this.cmndef.Showtoast(this.languageContext.starred);
    }, err => {

    })
  }

  unstarredmessage() {
    this.cancelSpeech()
    let res: any;
    let len: any;
    let starlen: any;
    this.canceltackback("nocall");
    res = {
      "conversationId": this.SelectedChat['conversationId'],
      "starred": "0",
      "userChatSessionId": localStorage.userChatSessionId,
      "userSessionID": localStorage.userSessionId
    }
    len = (this.cmndeclaration.ChatfullList.length) - this.SelectIndex;
    starlen = (this.cmndeclaration.ChatFullHistory.length) - len;
    this.api.postapi("starredMessage", res).then(data => {

      this.canceltackback("call");
      this.cmndeclaration.ChatfullList[this.SelectIndex]['starredmsg'] = 'false';
      this.cmndeclaration.ChatFullHistory[starlen]['starredmsg'] = 'false';
      this.clipboardBack();
      this.cmndeclaration.StoreChatHistory();
      this.cmndef.Showtoast(this.languageContext.unstarred);
    }, err => {

    })
  }

  clearChat() {
    this.capList = [];
    this.clearChatHistory();
    this.storeColorNumber = 0;
    this.cmndeclaration.checkMobileNumberEntered = false;
    this.storeChatData = '';
    this.storeDownloadAppData = false;
    this.sendChatData = false;
    this.storeLinkText = '';
    this.cmndeclaration.checkOtpEntered = false;
    this.storeOtp = '';
    this.ngOnInit();
  }
  Clearpreviouschat() {
    if (localStorage.log == "enable") {

      this.cmndef.showConfirmAlert("", this.languageContext.chatsessionexprmsg, "previouschat", this.languageContext.no, this.languageContext.yes);
      localStorage.log = "disable"
    }
  }

  clearChatHistory() {
    let starredmessage = [];
    let storeMessage = [];
    let curdate: any;
    let date = new Date();
    this.canceltackback("nocall");
    this.cmndeclaration.ChatFullHistory.forEach(chat => {
      if (chat.cType == "welcome") {

        if (starredmessage.length == 0) {
          starredmessage.push(chat);
          storeMessage.push(chat);
        }
        else {
          if (starredmessage[(starredmessage.length) - 1].cType == "welcome") {
            starredmessage.pop();
            storeMessage.pop();
            starredmessage.push(chat);
            storeMessage.push(chat);
          } else {
            starredmessage.push(chat);
            storeMessage.push(chat);
          }
        }
      } else if (chat.hasOwnProperty('starredmsg')) {
        if (chat.starredmsg != undefined && chat.starredmsg == 'true') {
          storeMessage.push(chat);
          starredmessage.push(chat);
        }
      }
    });
    if (starredmessage.length > 0) {
      if (starredmessage[(starredmessage.length) - 1].cType == "welcome") {
        curdate = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
        curdate = curdate + "  " + this.formatAMPM(date);
        starredmessage[(starredmessage.length) - 1].time = curdate;
        storeMessage[(starredmessage.length) - 1].time = curdate;
      }
    }
    this.cmndeclaration.ChatfullList = starredmessage;
    this.cmndeclaration.ChatFullHistory = [];
    this.cmndeclaration.ChatFullHistory = storeMessage;
    this.cmndeclaration.StoreChatHistory();
    setTimeout(() => {
      this.cd.detectChanges();
    }, 300)
    this.canceltackback("call");
  }

  activetackback() {
    let sec = Math.floor((Math.random() * 30) + 60) * 1000;

    if (this.tackbackInterval == "") {
      this.tackbackInterval = setTimeout(() => {
        if (localStorage.tackbackenable == "true" && this.router.url == this.cmndeclaration.tackbackPage) {
          this.cancelSpeech();
          if (this.vachattxt == "" || this.vachattxt == undefined) {
            this.triggerMessage(this.tackbackquery);
            this.canceltackback("call");
          } else {
            this.canceltackback("call");
          }
        } else
          this.canceltackback("no");
      }, sec)
    }
  }

  canceltackback(flg: any) {
    clearTimeout(this.tackbackInterval);
    this.tackbackInterval = "";

    if (flg == "call") {
      if (localStorage.tackbackenable == "true") {

        this.activetackback();
      }
    }

  }

  copyText() {
    if (this.cmndeclaration.BrowserBuild != 1) {
      this.clipboard.copy(this.SelectedChat.text);
      this.cmndef.Showtoast(this.languageContext.msgcopy);
      this.clipboardBack();
      this.clipboard.paste().then(
        (resolve: string) => {

        },
        (reject: string) => {
          //  alert('Error: ' + reject);
        });
    } else {
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = this.SelectedChat.text;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      this.clipboardBack();
      document.execCommand('copy')
      document.body.removeChild(selBox);
      this.cmndef.Showtoast(this.languageContext.msgcopy)
    }
  }

  startlisten() {
    let langval: any;
    let options: any;


    this.canceltackback("nocall");
    if (localStorage.language == "en") {
      langval = "en-US"
    }
    else if (localStorage.language == "hi") {
      langval = "hi-IN"
    }

    if (this.cmndeclaration.runPlatform == 'android') {
      options = {
        "language": langval,
        "prompt": "",
        "showPopup": false
      }
    } else {
      options = {
        "language": langval,
        "prompt": "",
        "showPopup": false,
        "showPartial": true
      }
      this.sendTimeout = 0;
      this.speechData = "";
      this.clearlisten = setTimeout(() => {
        this.showvoicepopup = false;
        this.stoplisten();
        if (this.speechData != "" && this.speechData != null && this.speechData != undefined) {
          let words: any;
          words = (this.speechData).split(" ");
          let de = "";
          if (this.cmndeclaration.grammercontent.hasOwnProperty(this.speechData.toLowerCase())) {
            de = this.cmndeclaration.grammercontent[this.speechData.toLowerCase()];
            this.sendMessage(de);
          } else {
            words.forEach(element => {
              if (this.cmndeclaration.grammercontent.hasOwnProperty(element.toLowerCase()))
                de = de + " " + this.cmndeclaration.grammercontent[element.toLowerCase()]
              else
                de = de + " " + element;
            });
            this.sendMessage(de);
          }
        }
      }, 6000);
    }

    this.SpeechRecognition.startListening(options)
      .subscribe(
        (matches: string[]) => {
          // if (this.cmndeclaration.runPlatform == 'android') {
          this.showvoicepopup = false;
          let words = (matches[0]).split(" ");
          let de = "";
          if (this.cmndeclaration.grammercontent.hasOwnProperty(matches[0].toLowerCase())) {
            de = this.cmndeclaration.grammercontent[matches[0].toLowerCase()];
            this.sendMessage(de);
          } else {
            words.forEach(element => {
              if (this.cmndeclaration.grammercontent.hasOwnProperty(element.toLowerCase()))
                de = de + " " + this.cmndeclaration.grammercontent[element.toLowerCase()]
              else
                de = de + " " + element;
            });
            this.sendMessage(de);
          }
          // }
          this.speechData = matches[0];
          this.canceltackback("nocall");
        },
        (onerror) => {

          this.showvoicepopup = false;
          this.stoplisten();
        }
      );
  }

  stoplisten() {
    this.SpeechRecognition.stopListening();
  }

  async voiceRecognition() {
    this.cancelSpeech();

    var _this = this;
    if (!this.ActionBlock) {
      // if (this.platform.is("cordova")) {
      //   this.showvoicepopup = true;
      //   this.startlisten();
      // } else {
      this.showvoicepopup = true;
      await this.startlisten();
      // }
    }
  }

  voiceonresult(event): any {
    let current = event.resultIndex;
    let transcript = event.results[current][0].transcript;


  }

  showcontexal(flg) {
    this.cmndeclaration.loginedFlg = 'exist';
    this.cancelSpeech();
    if (flg == 'open')
      this.fabsub = 'menu';
    else if (flg == 'close')
      this.fabsub = ''
    else
      this.fabsub = 'menu';
  }


  contexualmenu(data: any, idx: any, flg: any) {
    let subdata: any;
    let rawData = JSON.parse(localStorage.usercontexual);
    if (flg == 'sub') {
      document.getElementById('menu' + idx).style.backgroundColor = '#8ead20';
      document.getElementById('menu' + idx).style.color = 'white';
    } else {
      document.getElementById('submenu' + idx).style.backgroundColor = '#8ead20';
      document.getElementById('submenu' + idx).style.color = 'white';
    }
    setTimeout(() => {
      this.Subqueries = [];
      if (data.subQueries == undefined) {
        this.fabsub = '';
        this.Subqueries = [];
        if (!this.ActionBlock) {
          this.api.clickenventcap(data.text);
          this.sendMessage(data.displayText)
        }
      } else {
        this.fabsub = 'submenu';
        if (flg == 'subsub')
          subdata = data["subQueries"];
        else
          subdata = rawData[idx]["subQueries"];
        this.Subqueries = subdata

        this.cd.detectChanges();
      }
    }, 300);
  }

  async TalismaTicket(data: any) {
    let respdata: any;
    data.time = this.formatAMPM(new Date);
    await this.cancelSpeech();
    if (localStorage.voiceenable == "true" && data.vText != undefined && data.vText != "") {
      await this.TalismaSpeech(data).then(async resp => {
        respdata = resp
        this.audio.src = respdata.url;
        await this.audio.load();
        await this.audio.play();
        setTimeout(() => {
          if (localStorage.language == "hi") {
            if (data.cType == "2") {
              for (let i = 0; i < data.buttons.length; i++) {
                if (this.cmndeclaration.lblButtons[data.buttons[i].actionName] != undefined && this.cmndeclaration.lblButtons[data.buttons[i].actionName] != "") {
                  data.buttons[i].actionName = this.cmndeclaration.lblButtons[data.buttons[i].actionName]
                  data.buttons[i].actionVal = this.cmndeclaration.lblButtons[data.buttons[i].actionVal]
                }
              }
            }
            if (data.cType == "4") {
              for (let i = 0; i < data.links.length; i++) {
                if (this.cmndeclaration.lblButtons[data.links[i].actionName] != undefined && this.cmndeclaration.lblButtons[data.links[i].actionName] != "") {
                  data.links[i].actionName = this.cmndeclaration.lblButtons[data.links[i].actionName]
                }
              }
            }
            if (data.cType == "11") {
              if (this.cmndeclaration.lblButtons[data.actionName] != undefined && this.cmndeclaration.lblButtons[data.actionName] != "") {
                data.actionName = this.cmndeclaration.lblButtons[data.actionName]
              }
            }
            if (data.cType == "21") {
              for (let i = 0; i < data.Buttons.length; i++) {
                if (this.cmndeclaration.lblButtons[data.Buttons[i].actionName] != undefined && this.cmndeclaration.lblButtons[data.Buttons[i].actionName] != "") {
                  data.Buttons[i].actionName = this.cmndeclaration.lblButtons[data.Buttons[i].actionName]
                }
              }
            }
          }
          this.cmndeclaration.ChatfullList.push(data);
          this.cmndeclaration.ChatFullHistory.push(data);
          this.cmndeclaration.Scrollbottom();
        }, 200);
        this.cmndeclaration.StoreChatHistory();
        this.cd.detectChanges();
      }, err => {

        setTimeout(() => {
          if (localStorage.language == "hi") {
            if (data.cType == "2") {
              for (let i = 0; i < data.buttons.length; i++) {
                if (this.cmndeclaration.lblButtons[data.buttons[i].actionName] != undefined && this.cmndeclaration.lblButtons[data.buttons[i].actionName] != "") {
                  data.buttons[i].actionName = this.cmndeclaration.lblButtons[data.buttons[i].actionName]
                  data.buttons[i].actionVal = this.cmndeclaration.lblButtons[data.buttons[i].actionVal]
                }
              }
            }
            if (data.cType == "4") {
              for (let i = 0; i < data.links.length; i++) {
                if (this.cmndeclaration.lblButtons[data.links[i].actionName] != undefined && this.cmndeclaration.lblButtons[data.links[i].actionName] != "") {
                  data.links[i].actionName = this.cmndeclaration.lblButtons[data.links[i].actionName]
                }
              }
            }
            if (data.cType == "11") {
              if (this.cmndeclaration.lblButtons[data.actionName] != undefined && this.cmndeclaration.lblButtons[data.actionName] != "") {
                data.actionName = this.cmndeclaration.lblButtons[data.actionName]
              }
            }
            if (data.cType == "21") {
              for (let i = 0; i < data.Buttons.length; i++) {
                if (this.cmndeclaration.lblButtons[data.Buttons[i].actionName] != undefined && this.cmndeclaration.lblButtons[data.Buttons[i].actionName] != "") {
                  data.Buttons[i].actionName = this.cmndeclaration.lblButtons[data.Buttons[i].actionName]
                }
              }
            }
          }
          this.cmndeclaration.ChatfullList.push(data);
          this.cmndeclaration.ChatFullHistory.push(data);
          this.cmndeclaration.Scrollbottom();
        }, 200)
        this.cmndeclaration.StoreChatHistory();
        this.cd.detectChanges();
      });
    } else {
      setTimeout(async () => {
        this.cmndeclaration.ChatfullList.push(data);
        this.cmndeclaration.ChatFullHistory.push(data);
        this.cmndeclaration.StoreChatHistory();
        this.cd.detectChanges();
        this.cmndeclaration.Scrollbottom();
      }, 200)
    }
  }

  async verifyOtpback() {
    let data: any;
    let res: any;
    await this.cmndef.loaderstart();
    data = {
      queryReq: "&asswordBack",
      speechMode: "0",
      userChatSessionID: localStorage.userChatSessionId,
      userSessionID: localStorage.userSessionId
    }
    await this.api.postapi("akeiraVAChat", data).then(async data => {

      res = data;
      await this.cmndef.loaderend();
      this.TalismaTicket(res.chatResp[0]);
      // this.cd.detectChanges();
    }, async err => {

      await this.cmndef.loaderend();
    });
  }

  async TalismaSpeech(data: any) {
    let lang: any;
    let speechtext: any;
    return new Promise(async (resolve, reject) => {
      this.cancelSpeech();
      if (localStorage.language == 'hi')
        lang = "hi-IN"
      else
        lang = "en-IN"
      speechtext = {
        "voice": "Aditi",
        "LanguageCode": lang,
        "TextType": "text",
        "text": data.vText
      }
      await this.cmndeclaration.Amazonpoliy(speechtext).then(resp => {
        resolve(resp);
      }, err => {
        reject(err);
      });

    })
  }


  userLogout(flg: any) {

    this.cancelSpeech()
    localStorage.removeItem("tackbackenable");
    if (flg == "manual") {
      let req = {
        userChatSessionId: localStorage.userChatSessionId,
        userSessionID: localStorage.userSessionId,
        "requestType": "LOGOUT"
      }
      this.api.postapi("loginAuthentication", req).then(data => {

        localStorage.logout = flg;
        sessionStorage.CurrentPage = "/loginva";
        this.clipboardBack();
        this.navCtrl.navigateForward("/loginva")
      }, err => {

      })
    } else if (flg == "proslogut") {
      this.clipboardBack();
      sessionStorage.CurrentPage = "/login";
      this.navCtrl.navigateRoot("/login");
    } else {
      if (localStorage.role == 'new') {
        localStorage.removeItem("user");
        localStorage.removeItem("dobdate");
        localStorage.removeItem("logined");
        localStorage.removeItem("role");
        localStorage.removeItem("dob");
        sessionStorage.removeItem("profile");
        localStorage.removeItem("logout");
        this.cmndeclaration.deletefile();
        this.cmndeclaration.ChatFullHistory = [];
        this.cmndeclaration.ChatfullList = [];
        this.capList = [];
        localStorage.removeItem("uniqueId");
        localStorage.removeItem("userChatSessionId");
        localStorage.removeItem("userChatSessionID");
        localStorage.removeItem("userSessionID");
        localStorage.removeItem("tackbackenable");
        localStorage.removeItem('nothanks');
        localStorage.removeItem('banner');
        localStorage.removeItem("voiceenable");
        localStorage.removeItem('policyNo');
        this.clipboardBack();
        sessionStorage.CurrentPage = "/preRegister";
        this.navCtrl.navigateRoot("/preRegister");
      } else {
        this.clipboardBack();
        sessionStorage.CurrentPage = "/loginva";
        this.navCtrl.navigateForward("/loginva");
      }
    }
  }

  downloadDocument(getVal: any) {
    let filename: any;
    let folderpath: any;
    let date: any;
    setTimeout(() => {
      this.cmndef.Showtoast('Downloading...');
    });
    let contentType = "application/pdf";
    folderpath = this.file.dataDirectory;

    date = (getVal.date == undefined || getVal.date == "") ? "" : getVal.date;

    if (getVal.name == "e-Policy Document") {
      filename = getVal.name + ".pdf";
    } else {
      filename = getVal.text + date + ".pdf";
    }
    filename = filename.replace(/ /g, '').replace(/\//g, '_');
    this.savebase64AsPDF(folderpath, filename, getVal.blob, contentType);
  }


  savebase64AsPDF(folderpath, filename, content, contentType) {
    let DataBlob = this.b64toBlob(content, contentType, '');
    if (this.cmndeclaration.BrowserBuild == 1) {
      let a: any = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      let url = window.URL.createObjectURL(DataBlob);
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.file.resolveLocalFilesystemUrl(folderpath).then(DirectoryEntry => {
        this.file.writeFile(folderpath, filename, DataBlob, { replace: true }).then(data => {
          this.cmndef.Showtoast(filename + ' has been download');
          setTimeout(() => {
            this.openPDF(folderpath + filename);
          }, 600);
        }, err => {

        })
      }, err => {
        this.cmndef.Showtoast('Please given a File Persmission to Download the file');
      })
    }
  }

  openPDF(getPath) {
    console.log(getPath);
    this.fileopener.showOpenWithDialog(getPath, 'application/pdf')
      .then(() => console.log('File is opened'))
      .catch(e => console.log('Error opening file', e));
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  deletereminder() {
    let req: any;
    let res: any;
    let cards: any;

    this.cancelSpeech();
    if (this.cmndef.logoutFlg == 0) {
      this.cmndef.logoutFlg = 1;
      this.cmndef.loaderstart();
      req = {
        actionType: "DeleteReminder",
        langCode: localStorage.language,
        reminderId: this.reminderId,
        userChatSessionId: localStorage.userChatSessionId,
        userSessionId: localStorage.userSessionId,
      }
      this.api.postapi('reminder', req).then(data => {
        res = data;
        this.cmndef.logoutFlg = 0;
        cards = this.cmndeclaration.ChatfullList[(this.cmndeclaration.ChatfullList.length) - 1].cards;
        this.cmndeclaration.ChatfullList[(this.cmndeclaration.ChatfullList.length) - 1].cards = [];
        for (let i = 0; i < cards.length; i++) {
          if (cards[i].reminderId != this.reminderId) {
            this.cmndeclaration.ChatfullList[(this.cmndeclaration.ChatfullList.length) - 1].cards.push(cards[i]);
          }
        }
        this.cmndef.loaderend();
        if (localStorage.voiceenable == "true")
          this.TalismaTicket(res.chatResp[0]);
        else {
          this.cmndeclaration.ChatfullList.push(res.chatResp[0]);
          this.cmndeclaration.ChatFullHistory.push(res.chatResp[0]);
          this.cmndeclaration.StoreChatHistory();
          setTimeout(() => {
            this.cmndeclaration.Scrollbottom();
          }, 200)
        }
      }, err => {
        this.cmndef.loaderend();
        this.cmndef.logoutFlg = 0;

      })
    }
  }

  searchChat() {
    this.SearchJson = [];

    this.SearchJson = this.cmndeclaration.ChatfullList.filter(chat => (chat.text != undefined && (chat.text.toLowerCase()).indexOf(this.searchText.toLowerCase()) != -1));

    var mssg = this.cmndeclaration.LanguageJson.pages[0].alerts.vafound;
    if (this.searchText != "")
      this.cmndef.Showtoast("(" + this.SearchJson.length + ") " + mssg + " ");
  }

  searchbelow() {
    let req: any;
    for (let i = this.currentSearchedidx; i < this.cmndeclaration.ChatfullList.length; i++) {
      if (this.cmndeclaration.ChatfullList[i].text != undefined) {
        if ((this.cmndeclaration.ChatfullList[i].text.toLowerCase()).indexOf(this.searchText.toLowerCase()) != -1) {
          this.scrollchat("id" + i);
          this.SelectIndex = [i];
          this.currentSearchedidx = i + 1;
          break;
        }
      }
    }
  }

  searchabove() {
    if (this.currentSearchedidx >= this.cmndeclaration.ChatfullList.length)
      this.currentSearchedidx = this.currentSearchedidx - 1;

    for (let i = this.currentSearchedidx; i >= 0; i--) {
      if (this.cmndeclaration.ChatfullList[i].text != undefined) {
        if ((this.cmndeclaration.ChatfullList[i].text.toLowerCase()).indexOf(this.searchText.toLowerCase()) != -1) {
          this.scrollchat("id" + i);
          this.SelectIndex = [i];
          this.currentSearchedidx = i - 1;
          break;
        }
      }
    }
  }

  scrollchat(idname: any) {
    var element = document.getElementById(idname);
    var alignWithTop = false;
    //mydiv.nextSibling();
    element.scrollIntoView(alignWithTop);

  }

  getNotification() {
    let data: any;
    if (localStorage.notification != undefined && localStorage.notification) {
      data = JSON.parse(localStorage.notification);



      if (data != undefined && data != "") {
        let action = data.additionalData.click_action.toUpperCase();
        let text = data.additionalData.text;
        if (action != undefined && action.indexOf('CAMPAIGN') > -1) {
          this.sendMessage(text);
          localStorage.removeItem("notification");
        } else {
          if (text != undefined) {
            this.TalismaTicket({
              "cType": "1",
              "text": text
            });
            localStorage.removeItem("notification");
          }
        }
      }
    }
  }

  callinformationpopup() {
    var popupdata: any = [];
    if (localStorage.configPage != undefined && localStorage.configPage != "") {
      popupdata = JSON.parse(localStorage.configPage);
      popupdata = popupdata.values;

      if (localStorage.popup == undefined || localStorage.popup == "") {
        this.contexalpopup = true;
        this.contpopupCont = JSON.parse(localStorage.configPage);
        for (let i = 0; i < this.contpopupCont.values.length; i++) {
          if (this.contpopupCont.values[i].popupType == "I") {
            this.popcontnt = this.contpopupCont.values[i].popupContent;
            break;
          }
        }
      } else {
        this.contexalpopup = false;
      }

      if (localStorage.getItem('nothanks') == 'true') {
        this.showinformationpopup = false;
      } else {
        for (var s = 0; s < popupdata.length; s++) {
          if (popupdata[s].popupType == 'I' && popupdata[s].popupDeviceType == 'A') {
            this.showinformationpopup = true;
            this.informationpopup = popupdata[s];
            this.popupcontent = this._sanitizer.bypassSecurityTrustHtml(this.informationpopup['popupContent']);

            this.popupBtn = this.informationpopup['popupButton'].split(',');
            this.popupUrl = this.informationpopup['popupActionUrl'].split(',');
            this.popupAction = this.informationpopup['popupActionType'].split(',');

          }
        }
      }
    }
  }

  updateinfopopup() {
    this.showinformationpopup = false;

    localStorage.setItem('nothanks', 'true');
  }

  passlinkroute(idx, value) {


    if (this.popupAction[idx] == 'URL') {
      this.api.clickenventcap("contex_" + this.popupUrl[idx]);
      sessionStorage.CurrentPage = this.popupUrl[idx];
      this.navCtrl.navigateForward(this.popupUrl[idx])
    }
    else if (this.popupAction[idx] == 'link') {
      this.api.clickenventcap("contex_" + this.popupUrl[idx]);
      this.Loadingappbrowser("contex", this.popupUrl[idx])
    } else if (this.popupAction[idx] == 'QUERY') {
      this.api.clickenventcap("contex_" + this.popupBtn[idx]);
      this.sendMessage(this.popupBtn[idx]);
    }
    this.showinformationpopup = false;
    localStorage.setItem('nothanks', 'true');
  }

  async loadData(event) {
    let pushlen = 15;
    if (this.cmndeclaration.ChatFullHistory != undefined && this.cmndeclaration.ChatFullHistory != "" && this.cmndeclaration.ChatFullHistory != null) {
      let len = this.cmndeclaration.ChatFullHistory.length - this.cmndeclaration.ChatfullList.length;
      for (let i = (len - 1); i >= 0; i--) {


        if (pushlen == 0) {
          this.cmndeclaration.ChatfullList.unshift(this.cmndeclaration.ChatFullHistory[i]);
          break;
        } else {
          this.cmndeclaration.ChatfullList.unshift(this.cmndeclaration.ChatFullHistory[i]);
        }
        pushlen--;
      }
      await this.cd.detectChanges();
      setTimeout(() => {
        event.target.complete();
      }, 1000)
    }
    event.target.complete();

  }

  // hideCrossSell() {
  //   const element = <HTMLElement>document.getElementsByClassName('crossSellBanner')[0];
  //   element.style.display = 'none';
  // }

  RemoveData(event) {
    if (this.cmndeclaration.ChatfullList.length > 15) {
      let len = this.cmndeclaration.ChatfullList.length - 15;
      this.cmndeclaration.ChatfullList.splice(0, len);
    }
    event.target.complete();
    this.cd.detectChanges();
  }

  //samples
  shownotifications() {
    sessionStorage.CurrentPage = "/va/notification"
    this.api.clickenventcap("notification_icon");
    this.navCtrl.navigateForward("/va/notification");
  }

  validateText() {
    this.searchText = this.searchText.replace(/[^A-Za-z0-9!@#$%^&*()-+_.,'"]/g, '');
  }

  redirectToOtpVerifyPage() {
    let userInfo: any;
    this.cmndeclaration.getstoreProcess("profile").then(resq => {
      userInfo = resq;

      var data = {
        "actionType": "OTPREQUEST",
        "userSessionID": localStorage.userSessionId,
        "userChatSessionID": localStorage.userChatSessionId
      };
      this.api.postapi("otpRequest", data).then(res => {
        if (res['responseCode'] == "001" || res['status'] == "Success") {
          userInfo.state = res['state'];
          localStorage.state = res['state'];
          this.cmndeclaration.storeProcess(userInfo, "profile");
          this.cmndef.previousPage = "";
          sessionStorage.CurrentPage = "/verifyOtpPassword"
          this.navCtrl.navigateForward("/verifyOtpPassword")
        }
      }, err => {

      })
    })
  }


}
